import React from "react";
import { useNavigate } from "react-router-dom";
import { Container, Row, Col, Carousel, Button } from "react-bootstrap";
import { destinations } from "../data/destinationsData";
import "../css/PopularDestination.css";

const PopularDestinations = () => {
  const navigate = useNavigate();

  const handleRedirect = (destination) => {
    navigate(`/destination/${destination.id}`, { state: { destination } });
  };

  return (
    <section
      className="popular-destinations-section py-5 mt-4 text-dark"
      style={{
        width: "100vw",
        minHeight: "100vh",
        padding: "60px 20px",
        overflowX: "hidden",
      }}
    >
      <Container fluid style={{ maxWidth: "", margin: "0 auto" }}>
        <h2
          className="topDestination-title text-center mb-5"
          style={{
            fontSize: "2.5rem",
            fontFamily: "'EB Garamond', serif",
            fontStyle: "italic",
            fontWeight: "bold",
            letterSpacing: "1.5px",
            color: "#333",
          }}
        >
          Destinations to Explore
        </h2>

        <div className="custom-carousel-wrapper position-relative">
          <Carousel interval={7000} controls indicators className="custom-carousel">
            {destinations.map((item, index) => (
              <Carousel.Item key={index}>
                <div
                  className="d-flex flex-column align-items-center justify-content-center"
                  style={{ textAlign: "center" }}
                >
                  {/* Top Image */}
                  <img
                    src={item.image}
                    alt={item.title}
                    className="img-fluid rounded"
                    loading="lazy"
                    style={{
                      width: "80%",
                      // maxHeight: "400px",
                      objectFit: "cover",
                      transition: "transform 0.4s ease",
                    }}
                    onMouseOver={(e) =>
                      (e.currentTarget.style.transform = "scale(1.02)")
                    }
                    onMouseOut={(e) =>
                      (e.currentTarget.style.transform = "scale(1)")
                    }
                  />

                  {/* Bottom Content */}
                  <div
                    className="carousel-content mt-4 px-4"
                    style={{
                      maxWidth: "800px",
                      margin: "0 auto",
                      marginBottom: "55px",
                    }}
                  >
                    <h3 className="fw-bold mb-3">{item.title}</h3>
                    <p className="mb-4">{item.desc1}</p>
                    <Button
                      size="lg"
                      onClick={() => handleRedirect(item)}
                      className="custom-gradient-btn"
                    >
                      Discover Now
                    </Button>
                  </div>
                </div>
              </Carousel.Item>
            ))}
          </Carousel>
        </div>
      </Container>
    </section>
  );
};

export default PopularDestinations;
